import { Injectable } from '@angular/core';
import { QueryParams } from '../../models/Utilities/QueryParamEntity';
import * as appApiResources from '../../../shared/globalcontants';
import { FormGroup } from '@angular/forms';
import { OdataConfigurationService } from '../odata-configuration.service';
import { FieldEdmType } from '../../../shared/globalcontants';
import moment from 'moment-timezone';
import { CommonService } from '../common.service';
export interface PostHeadModel {
  [propName: string]: any;
}
@Injectable({ providedIn: 'root' })
export class RequestService {
  constructor(private odataConfiguration: OdataConfigurationService, public _CommonService: CommonService) { }

  /**
   * @version UI-13.1
   * constractRequestParams
   */

  constractRequestParams(queryParams: QueryParams): any {
    try {
      queryParams.filter = '';
      const keys = Object.keys(queryParams);
      let query = '';
      keys.forEach((data, index) => {
        if (data !== 'isactive' && data !== 'search' && data !== 'searchtext' && data !== 'filterQuery') {
          if (queryParams[data] !== '' && data !== 'filter') {
            if (index === 0) {
              query = query + '?$';
            } else {
              if (query.length > 0) {
                query = query + '&$';
              } else {
                query = query + '?$';
              }
            }
            query = query + data + '=' + queryParams[data];
          } else if (data === 'filter') {
            if (queryParams.isactive) {
              queryParams[data] = 'IsActive eq true';
            }
            if (queryParams.searchtext && queryParams.searchtext.length > 0 && queryParams.search) {
              if (queryParams[data].length > 0) {
                queryParams[data] = queryParams[data] + ' and ' + queryParams.search;
              } else {
                queryParams[data] = queryParams.search;
              }
            }
            if (queryParams.filterQuery && queryParams.filterQuery.length > 0) {
              if (queryParams[data].length > 0) {
                queryParams[data] = queryParams[data] + ' and ' + queryParams.filterQuery;
              } else {
                queryParams[data] = queryParams.filterQuery;
              }
            }

            if (queryParams[data] !== '') {
              if (index === 0) {
                query = query + '?$';
              } else {
                query = query + '&$';
              }
              query = query + data + '=' + queryParams[data];
            }
          }
        }
      });
      return query;
    } catch (error) {
      console.error(error);
    }
  };

  /**
      * @description to form the query for api
      * @params searchBy
      * @params currentFilter
      * @params searchText
      * @params headerDefinition
      */
  formSearchQuery(searchBy: Array<any>, currentFilter: any, searchText: any) {
    const SearchText = searchText.replaceAll('\'', '\'\'');
    searchText = encodeURIComponent(SearchText).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
    searchBy.forEach(element => {
      if (element) {
        const query = 'contains(tolower(' + element.columnName + '),\'' + searchText.toLowerCase() + '\')';
        currentFilter = this.addFilter(currentFilter, query);
      }
    });
    return currentFilter;
  }

  addFilter(currentFilter, filter) {
    if (currentFilter.length === 0) {
      currentFilter = filter;
    } else {
      currentFilter += ' or ' + filter;
    }
    return currentFilter;
  }
  /**
* @method contractractLoUrl()
* @input SiteId or None
* @output Location Url String
* @description contract the location url
*/
  contractractLocUrl(): string {
    try {
      const sitesId = sessionStorage.getItem(appApiResources.loggedInSiteId) ? parseInt(JSON.parse(sessionStorage.getItem('loggedInSiteId')), 10) : 0;
      let LocationEndPointUrl = '';
      if (sitesId !== 1) {
        LocationEndPointUrl = `/inventory/api/Locations?$filter=(SiteId eq ${sitesId} or (LocationTypeId eq 10 and SiteId ne null) or (Id eq -1)) and IsActive eq true&$select=Id`;
      } else {
        LocationEndPointUrl = `/inventory/api/Locations?$filter=IsActive eq true and ((LocationTypeId ne 8 and SiteId ne null) or Id eq -1)&$select=Id`;
      }
      return LocationEndPointUrl;
    } catch (error) {
      return null;
      console.error(error);
    }
  }
  /**
   * @method PostRequestContraction()
   * @Input RequestTableData, Formdata 
   */
  PostRequestContraction(RequestTableData: Array<any>, FormData: any, PostModelHeaderKey: string, PostModelDetailKey: string): any {
    try {
      if (this.odataConfiguration.OdataCollection && this.odataConfiguration.OdataCollection) {
        const PostModelEntity: Array<any> = this.odataConfiguration.OdataCollection.OdataPostModelEntity;
        if (PostModelEntity && PostModelEntity.length > 0) {
          const ModelEntity = PostModelEntity.filter((ModelEntity: any) => ModelEntity['$']['Name'] === PostModelHeaderKey);
          let combinePostModel = {};
          if (ModelEntity && ModelEntity.length > 0) {
            const PostModel: Array<any> = ModelEntity[0]['Property'];
            if (PostModel && PostModel.length > 0) {
              combinePostModel = this.constractProperityObject(ModelEntity, FormData);
            }
          }
          const ModelDetailEntity = PostModelEntity.filter((ModelEntity: any) => ModelEntity['$']['Name'] === PostModelDetailKey);
          if (ModelDetailEntity && ModelDetailEntity.length > 0) {
            const DetailEntityName = ModelDetailEntity[0]['$']['Name'];
            combinePostModel[DetailEntityName] = [];
            const PostDetailModel: Array<any> = ModelDetailEntity[0]['Property'];
            if (PostDetailModel && PostDetailModel.length > 0 && RequestTableData && RequestTableData.length > 0) {
              const detailArray: Array<any> = [];
              RequestTableData.forEach(tableData => {
                const DetailObject = this.constractProperityObject(ModelDetailEntity, tableData);
                DetailObject.RecevingTolerance = tableData.RecevingTolerance;
                DetailObject.TransactionTaxAmount = tableData.TransactionTaxAmount;
                DetailObject.ConsignmentBatch = tableData.ConsignmentBatch;
                DetailObject.ExtendedCostDetail = tableData.ExtendedCostDetail;
                if(!this._CommonService.isonlineStatus) {
                  DetailObject.OnRecipt = tableData.OnRecipt;
                  DetailObject.SortOrder = tableData.SortOrder;
                }
                detailArray.push(DetailObject);
              })
              combinePostModel[DetailEntityName] = [...detailArray];
            }
          };
          return combinePostModel;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  constractProperityObject(EntityCollection: Array<any>, Collection: any): any {
    const PostDatas = {};
    EntityCollection[0].Property.forEach(element => {
      const edmType = element?.['$']?.Type;
      const isCollectionType = typeof edmType === 'string' && edmType.startsWith('Collection(');

      if (isCollectionType) {
        const elementName = element['$'].Name;
        const currentValue = Collection?.[elementName];
        const collectionInnerType = edmType.replace('Collection(', '').replace(')', '');
        // If inner type is not an Edm type (i.e., it's a custom complex type), use object, otherwise use array
        const isComplexType = !collectionInnerType.startsWith('Edm.');
        PostDatas[elementName] = Array.isArray(currentValue) ? currentValue : (isComplexType ? null : []);
        return;
      }

      if (Collection[element['$'].Name] !== null && Collection[element['$'].Name] !== '' && Collection[element['$'].Name] !== undefined) {
        PostDatas[element['$'].Name] = Collection[element['$'].Name];
        if (element['$'].Type === 'Edm.Int32') {
          if (Collection[element['$'].Name]?.toString()) {
            PostDatas[element['$'].Name] = parseInt(Collection[element['$'].Name], 10);
          } else {
            if (element['$'].hasOwnProperty('Nullable') && element['$'].Nullable === 'false' && element['$'].Name !== 'Id') {
              PostDatas[element['$'].Name] = this.setDeafultValue(element);;
            } else {
              PostDatas[element['$'].Name] = 0;
            }
          }
        } else if (element['$'].Type === 'Edm.Int16') {
          if (Collection[element['$'].Name]?.toString()) {
            PostDatas[element['$'].Name] = parseInt(Collection[element['$'].Name], 10);
          } else {
            if (element['$'].hasOwnProperty('Nullable') && element['$'].Nullable === 'false' && element['$'].Name !== 'Id') {
              PostDatas[element['$'].Name] = this.setDeafultValue(element);
            } else {
              PostDatas[element['$'].Name] = this.setDeafultValue(element);
            }
          }
        } else if (element['$'].Type === 'Edm.Decimal' || element['$'].Type === 'Edm.Single') {
          if (Collection[element['$'].Name]?.toString()) {
            PostDatas[element['$'].Name] = parseFloat(Collection[element['$'].Name]);
          } else {
            PostDatas[element['$'].Name] = 0;
          }
        } else if (element['$'].Type === 'Edm.DateTimeOffset') {
          PostDatas[element['$'].Name] = this.FormatDateTimeOffset(Collection[element['$'].Name]);
        }
        else if (element['$'].Type === 'Edm.String') {
          const elementName = element['$'].Name;
          if (Collection.hasOwnProperty(elementName) && Collection[elementName] !== '' && Collection[elementName] !== null) {
            PostDatas[elementName] = Collection[elementName].toString()
          } else {
            PostDatas[elementName] = this.setDeafultValue(element);
          }
        } else if (element['$'].Type === 'Edm.Duration') {
          const elementName = element['$'].Name;
          PostDatas[elementName] = (Collection[elementName] && Collection[elementName] !== null && Collection[elementName] !== '' && Collection[elementName] !== undefined) ? moment(Collection[elementName], 'hh:mm A').format('HH:mm:ss') : null;
        }
      } else {
        if (element['$'].Name !== 'Id') {
          PostDatas[element['$'].Name] = this.setDeafultValue(element);
        }
        if (element['$'].Type === 'Edm.Boolean' && element['$'].Name !== 'IsActive') {
          PostDatas[element['$'].Name] = false;
        }
        if (element['$'].Name === 'IsActive') {
          PostDatas[element['$'].Name] = PostDatas[element['$'].Name] ? PostDatas[element['$'].Name] : true;
        }
        if (element['$'].Type === 'Edm.Int16') {
          PostDatas[element['$'].Name] = this.setDeafultValue(element);
        }
      }
    });
    const NavigationPropertyNames = ['ReceivingItemsOtherTotals'];
    EntityCollection[0]?.NavigationProperty?.forEach(element => {
      if (NavigationPropertyNames.find(x => x === element['$'].Name)) {
        PostDatas[element['$'].Name] = Collection[element['$'].Name];
      }
    });
    return PostDatas;
  }

  FormatDateTimeOffset(DateObject: any): any {
    try {
      let FormatedDate = null;
      const checkValidDate = moment(DateObject).format();
      if (checkValidDate.toString() === 'Invalid Date') {
        const convertMomentDate = moment(DateObject, 'DD.MM.YYYY');
        const convertNewDate = moment(convertMomentDate).format();
        FormatedDate = this.CheckDateConversion(convertNewDate);
      } else {
        FormatedDate = this.CheckDateConversion(checkValidDate);
      }
      return FormatedDate;
    } catch (error) {
      console.error(error);
    }
  }

  CheckDateConversion(convertNewDate: any): any {
    try {
      let convertedDate = null;
      const date = moment(convertNewDate);
      if (date.isValid()) {
        convertedDate = date.format();
      }
      return convertedDate;
    } catch (error) {
      console.error(error);
    }
  }

  setDeafultValue(HeaderProperity: any) {
    try {
      const ModelType = HeaderProperity['$'].Type;
      const nullable = HeaderProperity['$'].hasOwnProperty('Nullable') ? true : false;
      if (typeof ModelType === 'string' && ModelType.startsWith('Collection(')) {
        return [];
      }
      let defaultValue: any = '';
      switch (ModelType) {
        case FieldEdmType.EDMINT32:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EDMINTDECIMAL:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EDMDATEOFFSET:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EDMSTRING:
          defaultValue = (nullable) ? '' : null;
          break;
        case FieldEdmType.EDMINT16:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EDMINT64:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EDMFLOAT:
          defaultValue = (nullable) ? 0 : null;
          break;
        case FieldEdmType.EMDBOOLEAN:
          defaultValue = (nullable) ? false : null;
          break;
        case FieldEdmType.EDMDOUBLE:
          defaultValue = (nullable) ? 0 : null;
          break;
        default:
          defaultValue = (nullable) ? '' : null;
      }
      return defaultValue;
    } catch (error) {

    }
  }

  getPostDateFilterQuery() {
    try {
      const dateFilter = Number(localStorage.getItem("filterValue")) > 0 ? Number(localStorage.getItem("filterValue")) * -14 : -6;
      const startdate = moment().add(dateFilter, 'd').format();
      const now_utc_start = moment(startdate).startOf('day').utc(true).format();
      return `${now_utc_start}`;
    } catch (error) {
      console.error(error);
    }
  }
}
